module.exports = __webpack_public_path__ + "assets/img/TDC.d2d13ae1.png";